import { useTranslation } from 'react-i18next';
import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step.description;

export const getDescription = ({ step, t }) => {
  const { activities = [] } = step.details;

  if (activities.length === 1) {
    return t("Delete Scheduled Activity '{{name}} '", {
      name: activities[0].label,
    });
  } else if (activities.length > 1) {
    return t('Delete {{amount}} Scheduled Activities', {
      amount: activities.length,
    });
  } else {
    return '';
  }
};

export default function DeleteScheduledActivityCard({ step, ...others }) {
  const { t } = useTranslation();
  return (
    <DraggableStepCard {...others}>{content({ step, t })}</DraggableStepCard>
  );
}
